import {useAppSelector} from '@/hooks';
import type {TextStylesObject} from '@PosterWhiteboard/classes/text-styles.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';

export function useGetKeyFromTextStylesActiveItem<T extends keyof TextStylesObject>(key: T): TextStylesObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'textStyles' in item && item.textStyles[key] !== undefined) {
      return item.textStyles[key];
    }

    return undefined;
  });
}
